import { apiFetch } from './auth';

const API_BASE = import.meta.env.VITE_API_URL || '';

export type ConnectorLifecycleState =
  | 'not_installed'
  | 'disabled'
  | 'detecting'
  | 'setup_required'
  | 'ready'
  | 'busy'
  | 'degraded'
  | 'quarantined'
  | 'update_required'
  | 'waiting_for_user_session';

export interface AgentConnectorStatus {
  schemaVersion: 'realplc.connector.capabilities.v1';
  connectorId: string;
  displayName: string;
  vendor: string;
  connectorVersion: string;
  protocolVersion: string;
  installed: boolean;
  enabled: boolean;
  ready: boolean;
  state: ConnectorLifecycleState;
  sessionMode: 'single-active-user';
  maxConcurrentJobs: number;
  supportedActions: string[];
  detectedProducts: Array<Record<string, unknown>>;
  runtimeBackends?: string[];
  /** Which Agent reported this connector; one organization's connectors can live on different machines. */
  agentId?: string | null;
  agentName?: string | null;
}

export interface RealPlcAgentIntegrationStatus {
  schemaVersion: 'realplc.agent.integration-status.v1';
  productName: 'RealPLC Agent';
  sessionMode: 'single-active-user';
  connectionState: 'online' | 'offline';
  agentId: string | null;
  agentName: string | null;
  coreVersion: string | null;
  lastSeenAt: number | null;
  connectors: AgentConnectorStatus[];
}

export async function loadRealPlcAgentIntegrationStatus(
  projectId?: string | null,
): Promise<RealPlcAgentIntegrationStatus> {
  const query = projectId ? `?projectId=${encodeURIComponent(projectId)}` : '';
  const response = await apiFetch(`${API_BASE}/api/agent-gateway/agents/connectors${query}`);
  if (!response.ok) {
    const error = await response.json().catch(() => null) as { message?: string } | null;
    throw new Error(error?.message || 'Failed to load RealPLC Agent integrations');
  }
  return response.json() as Promise<RealPlcAgentIntegrationStatus>;
}
